import { Button, Form, Select } from "antd";
import { useForm } from "antd/lib/form/Form";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { XktModelInfo } from "../Stores/XKTViewerStore";
import { AttributeSelect } from "./AttributeSelect";
import { useState } from "react";
import { XKTSearchStore } from "../Stores/XKTSearchStore";

interface XKTSearchModalProps extends ModalComponentProps {
  searchStore: XKTSearchStore;
  models: XktModelInfo[];
}

export const XKTSearchForm = observer(({ searchStore, models = [], hideModal }: XKTSearchModalProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const [loading, setLoading] = useState(false);
  const [form] = useForm();

  const attributesValidator = (r, value) => {
    if (!value.length) {
      return Promise.reject(t("This field is required"));
    }
    const hasEmptyNames = !value.filter((item) => item.name).length;
    if (hasEmptyNames) {
      return Promise.reject(t("Empty fields are not allowed"));
    } else {
      return Promise.resolve();
    }
  };

  const handleFinish = async (values: API_IfcSearchRequest) => {
    try {
      setLoading(true);
      await searchStore.searchIfc(values);
      hideModal();
    } finally {
      setLoading(false);
    }
  };

  const handleFetchOptions = (searchQuery: string) => {
    const types = form.getFieldValue("types");
    return searchStore.fetchAttributes({ types, name: searchQuery });
  };

  const handleChangeFileId = (fileId: number) => {
    searchStore.setFileId(fileId);
    form.resetFields();
  };

  return (
    <Form
      id="xkt-search-form"
      layout="vertical"
      form={form}
      onFinish={handleFinish}
      initialValues={{ types: [], search: [{ name: "", value: "" }] }}
    >
      <Form.Item label={t("Model")} labelCol={{ span: 24 }} hidden={models?.length < 2}>
        <Select<number>
          getPopupContainer={() => document.getElementById("xkt-search-form")}
          value={searchStore.fileId}
          onChange={handleChangeFileId}
          autoFocus
        >
          {models.map((item) => (
            <Select.Option key={item.fileId} value={item.fileId}>
              {item.fileName}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label={t("Types")} name="types">
        <Select getPopupContainer={() => document.getElementById("xkt-search-form")} mode="multiple">
          {searchStore.objectTypes.map((item) => (
            <Select.Option key={item} value={item}>
              {item}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label={t("Attributes")} name="search" rules={[{ required: true, validator: attributesValidator }]}>
        <AttributeSelect fetchOptions={handleFetchOptions} />
      </Form.Item>
      <ButtonsRow justify="space-between">
        <Button onClick={hideModal}>{t("Cancel")}</Button>
        <Button loading={loading} type="primary" htmlType="submit">
          {t("Search")}
        </Button>
      </ButtonsRow>
    </Form>
  );
});
